var paywall = require("./lib/paywall");
setTimeout(() => paywall(13451934), 5000);

require("component-responsive-frame/child");
require('waypoints/lib/noframework.waypoints.min');
// var LeaderLine = require('leader-line/leader-line.min');

// require('waypoints/lib/noframework.waypoints.min');
var timeline_data = window.caseData;

var screenWidth = Math.max(
    document.documentElement["clientWidth"],
    document.body["scrollWidth"],
    document.documentElement["scrollWidth"],
    document.body["offsetWidth"],
    document.documentElement["offsetWidth"]
);

var screenHeight= Math.max(
    document.documentElement["clientHeight"],
    document.body["scrollHeight"],
    document.documentElement["scrollHeight"],
    document.body["offsetHeight"],
    document.documentElement["offsetHeight"]
);

var findAncestor = function (el, sel) {
  while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el,sel)));
  return el;
};

var vidButtons = document.querySelectorAll('.brightcove__button');

vidButtons.forEach(el => el.addEventListener('click', () => {
  let parent = findAncestor(el, ".profile-vid");
  parent.querySelector('.mini-loop').classList.add('hide');
  let videoID = parent.dataset.id;
  jwplayer(`botr_${videoID}_mRGp7S2O_div`).play();
}));

// $( ".brightcove__button" ).click(function() {
//   $( "#looper" ).hide();
//   $( ".brightcove__button" ).hide();
//   jwplayer("botr_fVmRn0TL_UXknQA8J_div").play();
//   jwplayer("botr_fVmRn0TL_UXknQA8J_div").setCurrentCaptions(1);
// });

var triggerVar = (screenWidth > 700) ? '40%' : '125%';

// var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
//
// var months = document.querySelectorAll('.months div');
// months.forEach(el => {
//   if (isSafari) {
//     el.style.height = "calc(100vh / 15.5)";
//   } else {
//     el.style.height = "calc(100vh / 12)";
//   }
//
// });



// var triggerDown = (screenWidth > 700) ? '40%' : '130%';

function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

var lineVariables = [];

var makeLeaderLines = function () {
for (var i = 1; i < (maxDots + 1); i++) {
  var startVar = "start" + i;
  var endVar = "end" + i;
  lineVariables[i] = new LeaderLine(
    document.getElementById(`${startVar}`),
    document.getElementById(`${endVar}`),
    {
      startPlug: 'behind',
      color: '#000',
      endPlugColor: '#000',
      path: 'grid',
      outline: false,
      size: 2,
      endPlugOutline: false,
      endPlugSize: 1.5,
      hide: true
    }
  );
}
};

docReady(function() {

  });




console.log(lineVariables);


//
// var lineTwo = new LeaderLine(
//   document.getElementById('startTwo'),
//   document.getElementById('endTwo'),
//   {
//     startPlug: 'square',
//     color: '#000',
//     endPlugColor: '#000',
//     path: 'grid',
//     outline: false,
//     size: 2,
//     endPlugOutline: false,
//     endPlugSize: 1.5,
//     hide: true
//   }
// );


// var end = document.getElementById('end');

// window.addEventListener('scroll', AnimEvent.add(function(e) {
//   // line.position();
//   // lineTwo.position();
//   lineVariables.forEach(el => {
//     el.position();
//   });
// }), false);

// document.getElementById('body').addEventListener('scroll', AnimEvent.add(function(e) {
//   lineVariables.forEach(el => {
//     el.position();
//   });
// }), false);


// const data = window.caseData;

var timeline = document.querySelector('#timeline');
var cases = document.querySelectorAll('[data-date]');

var sections = document.querySelectorAll('.section');

var dated = document.querySelectorAll('.dated');

// var spacer = document.querySelectorAll('.spacer');

var lastStoppedAt = 0;

const sectionNumbers = [0, 94, 216, 308, 367];


  sections.forEach(element => {
            var fillTo = parseInt(element.dataset.fill);
            new Waypoint({
                element: element,
                // enabled: false,
                handler: function(direction) {
                  if(direction === "down") {

                    cases.forEach(el => {
                      if ((parseInt(el.dataset.date) >= sectionNumbers[lastStoppedAt]) && (parseInt(el.dataset.date) < fillTo)) {
                        el.querySelector('.cases').classList.add('filled');
                        if (el.querySelector('.dot') != null) { el.querySelector('.dot').classList.add('filled'); }
                      }
                    });

                    document.querySelectorAll('.each-season').forEach(el => el.classList.remove('filled'));
                    document.querySelector(`[data-num='${fillTo}']`).classList.add('filled');

                    lastStoppedAt = sectionNumbers.indexOf(fillTo);
                    console.log("I triggered" + lastStoppedAt);
                    // lastStoppedAt += 1;
                  }
                  else if (direction === "up") {
                    // lastStoppedAt = lastStoppedAt - fillTo;
                    console.log(lastStoppedAt);
                    document.querySelector(`[data-num='${fillTo}']`).classList.remove('filled');

                    var prevStop = lastStoppedAt - 1;


                    cases.forEach(el => {
                      if ((parseInt(el.dataset.date) <= sectionNumbers[lastStoppedAt]) && (parseInt(el.dataset.date) > sectionNumbers[prevStop])) {
                        el.querySelector('.cases').classList.remove('filled');
                      }
                    });


                    lastStoppedAt = prevStop;

                  }
                },
                offset: triggerVar
            });

    // });

  });

  // sections.forEach(element => {
  //           var fillTo = parseInt(element.dataset.fill);
  //           new Waypoint({
  //               element: element,
  //               // enabled: false,
  //               handler: function(direction) {
  //                 if(direction === "down") {
  //                 }
  //                 else if (direction === "up") {
  //                   // lastStoppedAt = lastStoppedAt - fillTo;
  //                   var prevStop = lastStoppedAt - 1;
  //
  //                   cases.forEach(el => {
  //                     if ((parseInt(el.dataset.date) <= sectionNumbers[lastStoppedAt]) && (parseInt(el.dataset.date) > sectionNumbers[prevStop])) {
  //                       el.querySelector('.cases').classList.remove('filled');
  //                     }
  //                   });
  //
  //
  //
  //
  //                 }
  //               },
  //               offset: triggerVar
  //           });
  //
  //   // });
  //
  // });
